// extracted by mini-css-extract-plugin
export var advance = "style-module--advance--fcf1d";
export var col = "style-module--col--857d6";
export var num = "style-module--num--9ff95";
export var row = "style-module--row--08437";